import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Actions} from '../../../../common/actions';
import {dateFormatShow, noTimeZoneShortISODate} from '../../../../common/constants/datesFormat';
import PartAnalysisForm from './form';
import './editPartAnalysis.scss';

class EditAnalysisPart extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(formValues) {
    const {code} = this.props;
    const getManualMadValiditySelected = moment(
      formValues.manualMadValidity,
      dateFormatShow
    );
    const manualMadValidityFormatted = getManualMadValiditySelected.format(
      noTimeZoneShortISODate
    );

    const valuesFormatted = {...formValues};
    valuesFormatted.manualMadValidity = manualMadValidityFormatted;

    return this.props.editAnalysis(code, valuesFormatted);
  }

  render() {
    const {code, goBack, push} = this.props;
    return (
      <PartAnalysisForm
        goBack={goBack}
        push={push}
        code={code}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  return {
    code,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {editAnalysis, withRouter} = Actions;

export default withRouter(connect(mapStateToProps, {editAnalysis})(EditAnalysisPart));
